(function () {
  'use strict';

  angular.module('tfc.retailer.StandardReports')
      .factory('DeviceTypeFilter', DeviceTypeFilterClass);

  function DeviceTypeFilterClass(BaseFilterType, FiltersHelper) {

    function DeviceTypeFilter(filterData, stateParams) {
      if (!(this instanceof DeviceTypeFilter)) return new DeviceTypeFilter(filterData, stateParams);

      BaseFilterType.call(this, filterData, stateParams);
    }

    DeviceTypeFilter.prototype = _.create(BaseFilterType.prototype, {
      formatFilterValues: function (filterData) {
        var deviceHierarchy = getDeviceHierarchy(filterData);
        return FiltersHelper.formatTreeFilter(deviceHierarchy);
      },
      selectedParams: function (stateParams) {
        return getSelectedParams(stateParams.deviceType);
      },
      isFilterSelected: function (stateParams) {
        return _.map(stateParams, function (deviceType) {
          return FiltersHelper.includesDefaultFn(deviceType);
        });
      }
    });

    function getDeviceHierarchy(filterData) {
      var splitDevice = _.map(filterData, function(device) { return device.split('_')});
      var groupedDevice = _.groupBy(splitDevice, function(device) { return _.head(device); });
      return _.map(groupedDevice, function(value,key) {
        return {
          name: key,
          dimensionType: "flat",
          values: _.flatMap(value, function(v) { return _.tail(v); } )
        }
      });
    }

    function getSelectedParams(stateParams) {
      var deviceTypes, subDeviceTypes;
      if(stateParams) {
        var deviceHierarchy = getDeviceHierarchy(stateParams);
        deviceTypes = _.map(deviceHierarchy, 'name');
        subDeviceTypes = _.flatMap(deviceHierarchy, 'values');
      }

      return [deviceTypes, subDeviceTypes];
    }

    return DeviceTypeFilter;

  }

})();